/**
 * ng-expertiza.ru
 */

'use strict';

import Vue from 'vue';
import VueForm from 'vue-form';
import './jQueryPlugins/Accordion';
import './jQueryPlugins/Modal';
import initHamburger from './parts/initHamburger';
import fixedHeader from './parts/fixedHeader';
import mainSliders from './parts/mainSlider';
import customScrollbar from './parts/customScrollbars';
import {mountVueComponent} from './parts/mountVueComponent';
import ModalCallback from './components/ModalCallback';
import ModalConsult from './components/ModalConsult';
import BigOrderForm from './components/OrderForm';
import SectionOrderForm from './components/SectionOrderForm';


console.log('jQuery version', $.fn.jquery);
console.log('Vue version', Vue.version);
Vue.config.devtools = true;
Vue.use(VueForm);

initHamburger();
fixedHeader();
mainSliders();
customScrollbar('#documents');
customScrollbar('#news-scroll');

import(
  /* webpackChunkName: "calc" */
  /* webpackMode: "lazy" */
  /* webpackExports: ["default", "named"] */
  './calc/Calculator'
  ).then(({ default: Calculator }) => {
  const $calc = $('#calculator0');

  if ($calc.length) {
    $calc.each(function (index, element) {
      new Vue({
        el    : element,
        render: h => h(Calculator),
      });
    });
  }
});

/**
 * Аккордионы
 */
$('.accordion').accordion({
    active: 1, // порядковый номер дефолтного активного элемента (по умолчанию - 1)
});

/**
 * Модальные окна
 */
mountVueComponent('call-me', ModalCallback);
mountVueComponent('free-consult', ModalConsult);

$('[data-toggle=modal]').modal();

/**
 * Формы
 */
mountVueComponent('big-order-form', BigOrderForm);
mountVueComponent('section-order-form', SectionOrderForm);

/**
 * Лайтбоксы
 */
$(function() {
    $('[rel=lightbox]').removeAttr('rel');
    $('.lightbox').fancybox({// Enable infinite gallery navigation
        buttons: [
            'zoom',
            //"share",
            //"slideShow",
            //"fullScreen",
            //"download",
            //'thumbs',
            'close',
        ],
    });
});
